import { SharedConstants } from "../../types/constants"
// @ts-expect-error: the import is outside of TS' scope
import constants from "../../../shared/src/constants.yaml"

export function getConstants(): SharedConstants {
  return constants as SharedConstants
}
